/**
 * 通用功能权限检查服务
 * @module generic-feature-permission-service
 */
import type { FeatureKey } from '../../domain/permission';

/**
 * 通用功能权限检查服务接口
 */
export interface GenericFeaturePermissionService {
    /**
     * 检查功能权限并执行回调
     * @param featureId 功能ID
     * @param callback 权限检查通过后执行的回调函数
     * @returns 回调函数的返回值
     */
    checkAndExecute<T = any>(featureId: FeatureKey, callback: () => T): T;

    /**
     * 检查功能权限并执行异步回调
     * @param featureId 功能ID
     * @param callback 权限检查通过后执行的异步回调函数
     * @returns 回调函数的返回值 Promise
     */
    checkAndExecuteAsync<T = any>(featureId: FeatureKey, callback: () => Promise<T>): Promise<T>;
}

export const GenericFeaturePermissionService = Symbol.for('GenericFeaturePermissionService');
